import ProductDescription from './ProductDescription'

const BrownRiceProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '003',
  IsBroadband: true,
  GrainSize: '',
  CookingType: '',
  OatVariety: '',
  GrainLength: '',
  otherType: '',
}

export default BrownRiceProduct
